import React, { useState } from 'react';
import styles from './accordionContainer.module.css';
import SolidChevron from '../../icons/SolidChevron';

const AccordionContainer = ({ 
  children, 
  categoryName, 
  defaultOpen = false,
  isGroup = false
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  
  const toggleAccordion = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  return (
    <div className={`${styles.accordionContainer} ${isGroup ? styles.groupContainer : ''}`}>
      <div className={styles.wrapperAccordion}>
        <div className={styles.accordion}>
          <div className={styles.item}>
            {/* Encabezado */}
            <div 
              className={`${styles.accordionHeader} ${isOpen ? styles.open : ''}`}
              onClick={toggleAccordion}
              aria-expanded={isOpen}
            >
              <div className={styles.headerContent}>
                <span className={styles.categoryName}>
                  {categoryName}
                </span>
                <SolidChevron 
                  color='var(--color-primary)' 
                  size='18px'
                  className={`${styles.chevron} ${isOpen ? styles.rotate : ''}`}
                />
              </div>
            </div>

            <div className={`${styles.contentWrapper} ${isOpen ? styles.contentWrapperOpen : ''}`}>
              <div >
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccordionContainer;